<template>
    <div class="form-list">

        <md-subheader>Forms</md-subheader>

        <md-list>
          <router-link
            v-for="form in forms"
            :key="form.id"
            :to="'/forms/'+form.id"
          >
            <md-list-item>
              <span class="md-list-item-text">{{ form.name }}</span>
            </md-list-item>
          </router-link>

          <router-link to="/forms/create">
            <md-list-item>
              <md-button class="full-width md-raised md-dense" :md-ripple="false">New Form</md-button>
            </md-list-item>
          </router-link>
        </md-list>
    </div>
</template>

<script>
export default {
  name: 'FormList',
  mounted () {
    this.$store.dispatch('fetchForms')
  },
  data () {
    return {

    }
  },
  computed: {
    forms () {
      return this.$store.getters['forms']
    }
  }
}
</script>

<style lang="scss" scoped>
 @import '../assets/theme.scss';

.full-width {
  width: 100%;
}
button.md-button.full-width.md-raised.md-dense.md-theme-default {
  box-shadow: none;
  width: 100%;
  margin: 0;
  padding: 10px;
  border-radius: 10px;
  background-color: whitesmoke;
  text-decoration: none !important;
  line-height: 36px;
  height: 36px;
}
button.md-button.full-width.md-raised.md-dense.md-theme-default:hover {
  background-color: $primary !important;
  color: white !important;
}

</style>



// WEBPACK FOOTER //
// src/components/FormList.vue